__turbopack_context__.v({
  "root": "BrowseTabs-module-scss-module__sVtnMW__root",
  "tab": "BrowseTabs-module-scss-module__sVtnMW__tab",
});
